import { KeyboardEvent, useCallback } from "react";

// ----------------------------------------------------------------------

type Options = {
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  role?: "checkbox" | "radio";
};

/**
 * Props de teclado/ARIA para uma linha clicável que alterna seleção
 * (checkbox/radio). Torna a linha focável e operável por Enter/Espaço.
 */
export function useRowToggle(onToggle: () => void, { checked, label, disabled, role = "checkbox" }: Options = {}) {
  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (disabled) return;
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onToggle();
      }
    },
    [onToggle, disabled]
  );

  return {
    role,
    tabIndex: disabled ? -1 : 0,
    "aria-checked": checked,
    "aria-label": label,
    "aria-disabled": disabled || undefined,
    onClick: disabled ? undefined : onToggle,
    onKeyDown,
  };
}
